import { CustomDropDown } from "../DataComponent";

export const DataProperty = {
  propertyName: "Data",
  propertyDisplay: "Data",
  propertyType: "array",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <CustomDropDown
        handlePropertyChange={handlePropertyChange}
        currentPropertyValues={currentPropertyValues}
        propertyName={this.propertyName}
      />
    );
  },
};
